import { render, staticRenderFns } from "./modelSet.html?vue&type=template&id=50fd60a5&scoped=true&lang=html&external"
import script from "./modelSet.js?vue&type=script&lang=js&external"
export * from "./modelSet.js?vue&type=script&lang=js&external"
import style0 from "./modelSet.scss?vue&type=style&index=0&id=50fd60a5&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fd60a5",
  null
  
)

export default component.exports